module.exports = __webpack_public_path__ + "static/media/proposal_verification_audio.74d3412d.mp3";